{
  "name": "windy-plugin-fxc-soundings",
  "version": "5.2.2",
  "type": "module",
  "private": true,
  "description": "Alternative sounding graphs with custom features for PG/HG pilots.",
  "author": "Victor Berchet",
  "repository": {
    "type": "git",
    "url": "https://github.com/vicb/flyxc.git",
    "directory": "libs/windy-sounding"
  },
  "bugs": {
    "url": "https://github.com/vicb/flyxc/issues"
  },
  "license": "MIT",
  "sideEffects": [
    "*.css",
    "*.less",
    "*.scss"
  ],
  "dependencies": {
    "@flyxc/windy-types": "workspace:*",
    "@reduxjs/toolkit": "catalog:default",
    "date-fns": "catalog:default",
    "geojson": "^0.5.0",
    "preact": "^10.29.8",
    "react-redux": "^9.3.0",
    "jsonc-eslint-parser": "catalog:default"
  },
  "devDependencies": {
    "@dotenvx/dotenvx": "catalog:default",
    "@preact/preset-vite": "catalog:",
    "@types/geojson": "^7946.0.16",
    "vite": "catalog:default"
  }
}
